import { useState } from 'react';
import { navLinks } from '@/mocks/home';

interface NavbarProps {
  onEnter: (message: string) => void;
}

export default function Navbar({ onEnter }: NavbarProps) {
  const [open, setOpen] = useState(false);

  return (
    <header id="top" className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
        <h1 className="flex shrink-0 items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-base"></i>
          </span>
          <span className="font-heading text-xl tracking-wide text-foreground-950">黑料入口</span>
        </h1>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onEnter('已为你打开主线路入口（演示）')}
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-flashlight-fill"></i>
            一键进入
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition hover:bg-background-100 md:hidden"
          >
            <i className={open ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-3 text-sm text-foreground-800 transition hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              onEnter('已为你打开主线路入口（演示）');
            }}
            className="mt-2 flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-flashlight-fill"></i>
            一键进入
          </button>
        </div>
      )}
    </header>
  );
}